import React from "react";
import { date, formatDate } from "../../../utilities/utils";

const DisplayEmployeeBlock = ({ state, context }) => {
  return (
    <div className="Search-result">
      <div className="row">
        <div className="col-6">
          <div className="result-label">
            <b>
              {context.t(
                "STD-Employer-Statement.form.Employee-Details.label.text.EEName"
              )}
              :-
            </b>
            {state.firstName.value ? state.firstName.value : ""}&nbsp;
            {state.lastName.value ? state.lastName.value : ""}
          </div>
        </div>

        <div className="col-6 result-label">
          <b>
            {context.t(
              "STD-Employer-Statement.form.label.text.Employee-ID/EIN"
            )}
            :-
          </b>
          {state.ein.value ? state.ein.value : ""}
        </div>
      </div>
    </div>
  );
};
export default DisplayEmployeeBlock;
